module.exports = __webpack_public_path__ + "teqbahn-assets/media/Dr. Moody Qureshi Photo.71662971.jpg";